import { generateActionForKey, generateActions } from "../generateActions";
import { eHocPhanMienActionsObj } from "../../action-types/hoc-phan-mien/hocPhanMienActions";
import { NotifyHelper } from "../../../helpers/toast";

export const hocPhanMienActions = {
    ...generateActions(eHocPhanMienActionsObj, "HOC_PHAN_MIEN"),
    ...generateActionForKey(eHocPhanMienActionsObj, "HOC_PHAN_MIEN", "LOAD_ERROR", (m) => {NotifyHelper.Error(m)}),
    ...generateActionForKey(eHocPhanMienActionsObj, "HOC_PHAN_MIEN", "INSERTS_ERROR", (m) => {NotifyHelper.Error(m)}),
    ...generateActionForKey(eHocPhanMienActionsObj, "HOC_PHAN_MIEN", "INSERTS_SUCCESS", () => {NotifyHelper.Success("Thành công")}),
    ...generateActionForKey(eHocPhanMienActionsObj, "HOC_PHAN_MIEN", "DELETES_ERROR", (m) => {NotifyHelper.Error(m)}),
    ...generateActionForKey(eHocPhanMienActionsObj, "HOC_PHAN_MIEN", "DELETES_SUCCESS", () => {NotifyHelper.Success("Thành công")}),
}